<template>
  <div>
    <v-card>
      <v-card-title class="text-h5">
        <h2>JCOM Table Approval</h2>
        <v-spacer></v-spacer>
        <v-btn color="#8950FC" @click="$router.push('/jcom/table/lists')"
          >Back
        </v-btn>
      </v-card-title>

      <v-card-text>
        <v-container>
          <br />
          <v-container class="py-0">
            <v-form ref="form" v-model="valid" lazy-validation id="createForm">
              <v-row wrap>
                <v-col cols="12" sm="6" lg="3" md="3">
                  <h6>Zone<small>(Optional)</small></h6>
                  <v-select
                    :items="ZoneCodeOptions"
                    :rules="ZoneCodeRules"
                    v-model="ZoneCode"
                    dense
                    clearable
                    required
                    outlined
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="6" lg="3" md="3">
                  <h6>Table Type<small>(Optional)</small></h6>
                  <v-select
                    :items="TableTypeOptions"
                    :rules="TableTypeRules"
                    v-model="TableType"
                    dense
                    clearable
                    required
                    outlined
                  ></v-select>
                </v-col>
              </v-row>
              <v-row wrap>
                <v-col align="center" cols="12" md="12">
                  <v-btn
                    :disabled="!valid"
                    color="success"
                    class="btn btn-primary font-size-h6 py-4 my-3 mr-3 white--text"
                    @click="searchForm"
                  >
                    Search
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-container>

          <v-container class="py-0" v-if="tableData1.length > 0">
            <v-row wrap>
              <v-col align="center" cols="12" md="12">
                <h3>{{ tableData1.length }} records found.</h3>
              </v-col>
            </v-row>
            <br />
            <v-row wrap>
              <v-col align="center" cols="12" md="12">
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
                ></v-text-field>
                <br />
                <v-data-table
                  class="elevation-1"
                  v-model="selected1"
                  :search="search"
                  :item-key="tableOptions1.ItemKey"
                  :single-select="tableOptions1.SingleSelectFlag"
                  :show-select="false"
                  :headers="tableColumns1"
                  :items="tableData1"
                  :items-per-page="tableOptions1.ItemsPerPage"
                  :footer-props="tableOptions1.FooterProps"
                >
                  <template v-slot:[`item.actions`]="{ item }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          size="25px"
                          color="success"
                          @click="openApproveDialog(item)"
                          v-bind="attrs"
                          v-on="on"
                        >
                          mdi-check-circle
                        </v-icon>
                      </template>
                      <span> Approve/Reject </span>
                    </v-tooltip>
                  </template>

                  <template v-slot:[`item.ApprovalStatus`]="{ item }">
                    <v-chip :color="item.ApprovalStatusColor" dark small>
                      {{ item.ApprovalStatus }}
                    </v-chip>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-container>
        </v-container>
      </v-card-text>
    </v-card>

    <v-dialog v-model="approveDialog" width="auto">
      <v-card>
        <v-toolbar color="primary" dense dark elevation="1">
          <v-toolbar-title>Approve/Reject New Table</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="closeApproveDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <!--<v-card-title class="text-h5">Approve/Reject New Table</v-card-title>-->
        <v-card-text>
          <v-container>
            <v-row wrap>
              <v-col cols="12">
                <v-card outlined>
                  <div class="pa-3 text-subtitle-1">
                    <p>
                      <strong>Name</strong>: {{ tableDetails.NewTableName }}
                    </p>
                    <p><strong>Member</strong>: {{ tableDetails.Member }}</p>
                    <p><strong>Order</strong>: {{ tableDetails.Order }}</p>
                    <p><strong>Zone</strong>: {{ tableDetails.Zone }}</p>
                    <p><strong>City</strong>: {{ tableDetails.City }}</p>
                    <p>
                      <strong>Table Type</strong>: {{ tableDetails.TableType }}
                    </p>
                    <p>
                      <strong>Description</strong>:
                      <span v-html="tableDetails.Description"></span>
                    </p>
                  </div>
                </v-card>
              </v-col>
              <v-col cols="12">
                <v-textarea
                  v-model="approveDescription"
                  label="Description"
                  outlined
                  rows="3"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            class="text-white"
            @click="closeApproveDialog"
            >Cancel</v-btn
          >
          <v-btn
            v-if="ApprovalStatus == 0 || ApprovalStatus == 2"
            color="error darken-1"
            @click="submitApproval('reject')"
            >Reject</v-btn
          >
          <v-btn
            v-if="ApprovalStatus == 0 || ApprovalStatus == 2"
            color="success darken-1"
            @click="submitApproval('approve')"
            >Approve</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";

export default {
  mixins: [common],
  data() {
    return {
      JciYearCodeFlag: false,
      JciYearCodeRules: [(v) => !!v || "Year is required"],
      JciYearCode: 12,
      JciYearCodeOptions: [],

      ZoneCodeRules: [],
      ZoneCode: "",
      ZoneCodeOptions: [],
      TableTypeRules: [],
      TableType: "",
      TableTypeOptions: [],

      tableData1: [],
      tableColumns1: [],
      tableOptions1: {},

      valid: true,

      DescriptionTxt: "",
      approveDialog: false,
      approveDescription: "",
      selectedItemToApprove: null,
      tableDetails: {},
      ApprovalStatus: "",
    };
  },
  mounted() {
    this.pageData();
    this.showData();
  },
  watch: {
    pageInfo: function () {
      this.pageData();
    },
  },
  methods: {
    openApproveDialog(item) {
      console.log("openApproveDialog called");
      this.selectedItemToApprove = item;
      this.approveDescription = "";
      this.DescriptionTxt = item.DescriptionTxt;
      //this.approveDialog = true;

      var server_url = companyConfig.apiURL;
      var token = this.$session.get("token");
      token = token == (null || undefined) ? 0 : token;
      var add_url = server_url + "api/jcom/new-table/show";
      var upload = {
        UserInterface: 1,
        NewTableId: this.selectedItemToApprove.JcomNewTableId,
      };
      console.log("upload=" + JSON.stringify(upload));
      console.log(
        "server_url=" + server_url + ", token=" + token + ", add_url=" + add_url
      );
      const thisIns = this;
      thisIns.ProgessStart = 1;
      thisIns
        .$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        })
        .then(function (response) {
          console.log("response=" + JSON.stringify(response));
          thisIns.ProgessStart = 0;
          var output = response.data.output;
          var flag = response.data.flag;
          var records = response.data.records;

          if (flag == 1) {
            thisIns.DescriptionTxt = records.Description;
            thisIns.tableDetails = records;
            thisIns.ApprovalStatus = records.ApprovalStatus;
            thisIns.approveDialog = true;
            thisIns.success = output;
          } else {
            thisIns.error = output;
            thisIns.toast("error", output);
          }
        })
        .catch(function (error) {
          thisIns.ProgessStart = 0;
          thisIns.tableData1 = [];
          thisIns.tableColumns1 = [];
          thisIns.error = error;
          thisIns.toast("error", "Failed to fetch records.");
        });
    },
    closeApproveDialog() {
      console.log("closeApproveDialog called");
      this.approveDialog = false;
      this.DescriptionTxt = "";
      this.selectedItemToApprove = null;
      this.approveDescription = "";
      this.tableDetails = {};
      this.ApprovalStatus = "";
    },

    submitApproval(action) {
      console.log("submitApproval called");
      var tr = this.selectedItemToApprove;

      if (!tr) {
        this.toast("error", "Invalid record selected");
        return;
      }

      var server_url = companyConfig.apiURL;
      var token = this.$session.get("token");
      token = token == (null || undefined) ? 0 : token;
      var add_url = server_url + "api/jcom/new-table/update-approval-status";

      var upload = {
        UserInterface: action === "approve" ? 1 : 2,
        NewTable: tr.JcomNewTableId,
        Description: this.approveDescription,
      };

      console.log("upload=" + JSON.stringify(upload));
      const thisIns = this;
      thisIns.ProgessStart = 1;

      this.$http({
        url: add_url,
        method: "POST",
        data: upload,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      })
        .then(function (response) {
          console.log("response=" + JSON.stringify(response));
          thisIns.ProgessStart = 0;
          var output = response.data.output;
          var flag = response.data.flag;
          if (flag == 1) {
            thisIns.toast("success", output);
            thisIns.closeApproveDialog();
            thisIns.searchForm();
          } else {
            thisIns.toast("error", output);
          }
        })
        .catch(function (error) {
          console.log("error=" + error);
          thisIns.ProgessStart = 0;
          thisIns.toast("error", "Something went wrong");
        });
    },

    pageData() {
      this.getZoneOptions();
      this.getTableTypeOptions();
    },

    getZoneOptions() {
      console.log("getZoneOptions called");
      this.tableData1 = [];
      this.ZoneCode = "";

      this.ZoneCodeOptions = [];

      var yearCode = this.JciYearCode;
      console.log("yearCode=" + yearCode);
      if (yearCode != "") {
        this.ZoneCode = "";
        var selectbox1_source = "ZoneCode";
        var selectbox1_destination = "ZoneCodeOptions";
        var selectbox1_url = "api/year-wise-zone-options";
        var selectbox1_conditions_array = {
          UserInterface: 4,
        };
        this.getSelectBoxOptions(
          selectbox1_source,
          selectbox1_destination,
          selectbox1_conditions_array,
          selectbox1_url
        );
      }
    },
    getTableTypeOptions() {
      console.log("getTableTypeOptions called");
      var selectbox1_source = "TableType";
      var selectbox1_destination = "TableTypeOptions";
      var selectbox1_url = "api/jcom/table-type/options";
      var selectbox1_conditions_array = {
        UserInterface: 1,
      };
      this.getSelectBoxOptions(
        selectbox1_source,
        selectbox1_destination,
        selectbox1_conditions_array,
        selectbox1_url
      );
    },

    searchForm() {
      console.log("searchForm called");

      //this.resetMessageTxt();

      var ZoneCode = this.ZoneCode;
      var TableType = this.TableType;
      console.log("ZoneCode=" + ZoneCode + ", TableType=" + TableType);

      var result = this.$refs.form.validate();
      console.log("result=" + result);

      if (result) {
        this.tableData1 = [];

        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/jcom/new-table/lists";
        var upload = {
          UserInterface: 2,
          Zone: ZoneCode,
          TableType: TableType,
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );

        const thisIns = this;
        var output = "";
        var records = [];
        var table_content = [];
        var successTxt = "";
        var errorTxt = "";
        var flag = 0;

        // thisIns.pageLoadingOn()
        thisIns.ProgessStart = 1;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            // thisIns.pageLoadingOff()
            thisIns.ProgessStart = 0;

            output = response.data.output;
            flag = response.data.flag;
            table_content = response.data.TableContent;
            console.log("output=" + output + ", flag=" + flag);

            var options = table_content.TableOptions;
            records = table_content.TableData;

            if (flag == 1) {
              thisIns.tableColumns1 = table_content.TableHeader;
              thisIns.tableOptions1 = options;
              thisIns.tableData1 = records;

              thisIns.toast("success", output);
            } else {
              console.log("error=" + output);
              thisIns.toast("error", output);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
          });
      } else {
        var message = "Kindy fill required fields and then submit";
        this.toast("error", message);
      }
    },
  },
};
</script>

<style scoped>
</style